/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ metres: NonNullable<unknown> }} Exercise_Sheet_Set_DistanceInputs */

const en_us2_exercise_sheet_set_distance = /** @type {(inputs: Exercise_Sheet_Set_DistanceInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.metres} m`)
};

const pt_br2_exercise_sheet_set_distance = /** @type {(inputs: Exercise_Sheet_Set_DistanceInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.metres} m`)
};

const es_419_exercise_sheet_set_distance = /** @type {(inputs: Exercise_Sheet_Set_DistanceInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.metres} m`)
};

const pt_pt2_exercise_sheet_set_distance = /** @type {(inputs: Exercise_Sheet_Set_DistanceInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.metres} m`)
};

const fr_fr2_exercise_sheet_set_distance = /** @type {(inputs: Exercise_Sheet_Set_DistanceInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.metres} m`)
};

const de_de2_exercise_sheet_set_distance = /** @type {(inputs: Exercise_Sheet_Set_DistanceInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.metres} m`)
};

const it_it2_exercise_sheet_set_distance = /** @type {(inputs: Exercise_Sheet_Set_DistanceInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.metres} m`)
};

/**
* | output |
* | --- |
* | "{metres} m" |
*
* @param {Exercise_Sheet_Set_DistanceInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const exercise_sheet_set_distance = /** @type {((inputs: Exercise_Sheet_Set_DistanceInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Exercise_Sheet_Set_DistanceInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_exercise_sheet_set_distance(inputs)
	if (locale === "es-419") return es_419_exercise_sheet_set_distance(inputs)
	if (locale === "pt-PT") return pt_pt2_exercise_sheet_set_distance(inputs)
	if (locale === "fr-FR") return fr_fr2_exercise_sheet_set_distance(inputs)
	if (locale === "de-DE") return de_de2_exercise_sheet_set_distance(inputs)
	if (locale === "it-IT") return it_it2_exercise_sheet_set_distance(inputs)
	return en_us2_exercise_sheet_set_distance(inputs)
});
export { exercise_sheet_set_distance as "exercise-sheet.set_distance" }